module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/5_63d20ee6be70422d59d6d05c29476df4.png";